// eslint-disable-next-line
import Apis from '@/Apis/_'
import { CadastroHospital } from '@/types/_'
import { CadastroHospitalConvenio } from '../interfaces/CadastroHospital'
import ResponseApi from '../interfaces/FactoryResponse'
import { CoreBase, ICoreBase } from './CoreBase'

class Hospital extends CoreBase implements IHospital {
  async upsertHospital(hospital: CadastroHospital): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.upsertHospital(hospital)
    return response
  }

  async cadastrarConvenioPlanos(convenios: CadastroHospitalConvenio[]): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.cadastrarConvenioPlanos(convenios)
    return response
  }

  async cadastrarConvenioProcedimentos(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.cadastrarConvenioProcedimentos(params)
    return response
  }

  async cadastrarConvenioFornecedores(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.cadastrarConvenioFornecedores(params)
    return response
  }

  async cadastrarMaterialOpmes(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.cadastrarMaterialOpmes(params)
    return response
  }

  async cadastrarEquipamentos(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.cadastrarEquipamentos(params)
    return response
  }
}

interface IHospital extends ICoreBase {
  upsertHospital(hospital: CadastroHospital): Promise<ResponseApi>
  cadastrarConvenioPlanos(convenios: CadastroHospitalConvenio[]): Promise<ResponseApi>
  cadastrarConvenioProcedimentos(params: any): Promise<ResponseApi>
  cadastrarConvenioFornecedores(params: any): Promise<ResponseApi>
  cadastrarMaterialOpmes(params: any): Promise<ResponseApi>
  cadastrarEquipamentos(params: any): Promise<ResponseApi>
}

export {
  Hospital,
  IHospital,
}
